import { Routes } from '@angular/router'

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./_pages/kanban/kanban.module').then(m => m.KanbanModule)
  }
]
